export enum EPromoCodeCategories {
  Electricity = 'electricity_fee',
  Cart = 'shopping_cart',
}
